module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home":"Back to map"},"es":{"home":"Volver a mapa"}}')
  delete Component.options._Ctor
}
